<template>
  <div class="nav-container" :class="{'white-nav-container':type}">
    <ul>
      <li>
        <router-link to="/index">首页</router-link>
      </li>
      <li>
        <a-dropdown>
          <a class="ant-dropdown-link" href="#"> 课程分类
            <a-icon type="down"/>
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-for="item in subjectList" :key="item.subjectId">
              <a href="#" @click="handleChange(item.subjectId)">{{ item.subjectTitle }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </li>

      <li>
        <!--                <a @click="toExclusiveCourses"> 专属课程</a>-->
        <a href="https://stu.myhope365.com" target="_blank"> 教学管理云平台</a>
        <!--                <router-link to="/other/exclusiveCourses" >专属课程</router-link>-->
      </li>
    </ul>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import common from "../../../mixin/common";

const {mapState} = createNamespacedHelpers('subject');

export default {
  mixins: [common],
  methods: {
    handleChange(value) {
      // this.$router.push({
      //     path: "/other/search",
      //     query: {
      //         subject: value
      //     }
      // })

      const {href} = this.$router.resolve({
        path: "/other/search",
        query: {
          subject: value
        }
      });
      window.open(href, '_blank');

    },
    toExclusiveCourses() {
      // this.$router.push({
      //     path: "/other/course-direction",
      //     query: {}
      // })

      console.log(this.$route.fullPath)
      if (this.$route.fullPath == "/other/course-direction") {
        return
      } else {
        const {href} = this.$router.resolve({
          path: "/other/course-direction",
          query: {}
        });
        window.open(href, '_blank');
      }

    }
  },
  computed: {
    ...mapState([
      "subjectList"
    ])
  },
  watch: {},
  props:{
    type:{
      type:Boolean,
      default:false
    }
  }
}
</script>

<style scoped lang="less">
.white-nav-container{
  a{
  color: #fff;
  }
}
a:hover {
  color: unset;
}

.nav-container {
  height: 30px;
  font-weight: 600;
  float: left;


  ul {
    li {
      float: left;
      margin: 0 25px 0 0;
      font-size: 16px;
    }
  }
}
</style>
